/**
 * Created by Administrador on 17/07/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('passengerTypes', {
                parent: 'app',
                url: '/passengerTypes',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/passengerType/passengerTypes.html',
                        controller: 'passengerTypesCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['passengerType','ageRange']);
                    }],
                    passengerTypes: ['passengerTypeService', function(passengerTypeService){
                        return passengerTypeService.getPassengerTypes();
                    }]
                }
            })
            .state('passengerTypeNew', {
                parent: 'app',
                url: '/passengerType/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/passengerType/passengerTypeNew.html',
                        controller: 'passengerTypeNewEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['passengerType','ageRange']);
                            }],
                            edit: [function(){
                                return false;
                            }],
                            passengerType: [function() {
                                return {};
                            }]
                        }
                    }
                }
            })
            .state('passengerTypeEdit', {
                parent: 'app',
                url: '/passengerType/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/passengerType/passengerTypeEdit.html',
                        controller: 'passengerTypeNewEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['passengerType','ageRange']);
                            }],
                            edit: [function(){
                                return true;
                            }],
                            passengerType: ['passengerTypeService', '$stateParams', function (passengerTypeService, $stateParams) {
                                return passengerTypeService.getPassengerType($stateParams.id)
                            }]
                        }
                    }
                }
            })
            .state('passengerTypeDisable',{
                parent: 'passengerTypes',
                url: '/passengerType/:id/disable',
                data: {
                    authorities: CONFIG.AUTHORITIES_ADMIN
                },
                onEnter: ['$stateParams','$state','$uibModal','linkService', function($stateParams,$state,$uibModal,linkService){
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/passengerType/passengerTypeDisable.html',
                        controller: 'modalPassengerTypeDisableCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'passengerType': ['passengerTypeService', function (passengerTypeService) {
                                return passengerTypeService.getPassengerType($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        linkService.reloadRoute('passengerTypes');
                    }, function() {
                        linkService.reloadRoute('^');
                    });
                }]
            })
    }
})();
